export const CUSTOM_DATASTORES_STORAGE_KEY = "custom-datastores";
